import TextArea from "./TextArea.js";
import TextField from "./TextField.js";
import Select from "./Select.js";
import Radio from "./Radio.js";
import MultiSelect from "./MultiSelect.js";
import MultiSelectRadio from "./MultiSelectRadio.js";
import Number from "./Number.js";
import './../../styles/Inputs.css';

import { useState } from "react";
import ImageUpload from "./ImageUpload.js";
import Slider from "./Slider.js";

function EditorFieldOptions({ 
    fieldOptions, 
    debug, 
    layerName, 
    expandedOnLoad,
    updateLayer,
    layerId
}) {
    const safeFieldOptions = fieldOptions ?? {};
    const fieldOptionEntries = Object.entries( safeFieldOptions );

    const allOpen = {};
    if ( expandedOnLoad ) {
        for ( const [ key , value ] of fieldOptionEntries ) {
            const expanded = value?.expanded ?? false;
            allOpen[key] = expanded;
        }
    }
    
    const [ expandedSections, setExpandedSections ] = useState( allOpen );
    const [ expandLayer , setExpandLayer ] = useState( true );

    const toggleAccordion = (key) => {
        setExpandedSections( ( prevState ) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const toggleLayer = (  ) => {
        setExpandLayer( prev => !prev );
    }

    const sections = [];
    for ( const [ key , value ] of fieldOptionEntries ) {
        const dropdownLabel = value.label;
        const dropdownOptionEntries = Object.entries( value.options );

        const dropdownOptionSections = []; 
        for ( const [ _key , _value ] of dropdownOptionEntries ) {
            const inputType = _value.input_type;
            const inputLabel = _value.label;
            const defaultValue = _value.value;
            const availableOptions = _value.options;
            const gridWidth = _value.grid_width;
            const icon = _value.icon;
            const gridWidthClass = gridWidth === 'HALF' ? 'half' : 'full';
            const respondsToId = _value.responds_to_setting_id;
            const respondsToValue = _value.responds_to_setting_value;
            const minValue = _value.min_value;
            const maxValue = _value.max_value;
            const stepAmount = _value.step;
            const units = _value.units;

            let visible = true;
            if ( respondsToId != null ) {
                visible = false;
                for ( const [ __key , __value ] of dropdownOptionEntries ) {
                    // if id is found and the value saved = respond to, visible is true
                    if ( __value.id === respondsToId ) {
                        const valueToCheck = __value.value;
                        if ( respondsToValue.includes(',') ) {
                            const possibleValues = respondsToValue.split(',');
                            for ( let k = 0; k < possibleValues.length; k++ ) {
                                if ( valueToCheck.includes( possibleValues[k] ) ) {
                                    visible = true;
                                    break;
                                }
                            }
                        } else {
                            if ( valueToCheck.includes( respondsToValue ) ) {
                                visible = true;
                            }
                        }

                        break;
                    }
                }   
            }
            const hiddenClass = visible === false ? 'hidden' : '';

            let optionEl = null;
            if ( inputType === 'textfield' ) {
                optionEl = ( 
                    <TextField 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon}
                        onChange={ ( newValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else if ( inputType === 'number' ) {
                optionEl = ( 
                    <Number 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon}
                        onChange={ ( newValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else if ( inputType === 'slider' ) {
                optionEl = ( 
                    <Slider 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon}
                        onChange={ ( newValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                        minValue={minValue}
                        maxValue={maxValue}
                        step={stepAmount}
                        units={units}
                    />
                    
                );
            }
            else if ( inputType === 'textarea' ) {
                optionEl = ( 
                    <TextArea 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon} 
                        onChange={ ( newValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            }
            else if ( inputType === 'select' ) {
                optionEl = ( 
                    <Select 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon} 
                        options={availableOptions} 
                        onChange={ ( option ) => {
                            let newValue = option?.value;
                            if ( option?.swatch ) {
                                newValue = option.swatch;
                            }

                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            }
            else if ( inputType === 'multi_select' ) {
                optionEl = ( 
                    <MultiSelect 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon} 
                        options={availableOptions} 
                        name={_key} 
                        onChange={ ( newValues ) => {
                            const finalNewValue = newValues.join(',');
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( finalNewValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else if ( inputType === 'radio' ) {
                optionEl = ( 
                    <Radio 
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon} 
                        options={availableOptions} 
                        name={_key}
                        onChange={ ( newValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( newValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else if ( inputType === 'multi_select_radio' ) {
                optionEl = ( 
                    <MultiSelectRadio
                        key={_key} 
                        label={inputLabel} 
                        defaultValue={defaultValue} 
                        gridWidth={gridWidth} 
                        icon={icon} 
                        options={availableOptions} 
                        name={_key} 
                        onChange={ ( newValues ) => {
                            const finalNewValue = newValues.join(',');
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( finalNewValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else if ( inputType === 'image_upload' ) {
                optionEl = ( 
                    <ImageUpload
                        key={_key} 
                        label={inputLabel} 
                        gridWidth={gridWidth} 
                        defaultValue={defaultValue}
                        icon={icon}
                        name={_key}
                        onUpload={ ( imgValue ) => {
                            const dictionaryKeys = [ key , 'options' , _key ];
                            updateLayer( imgValue , dictionaryKeys , layerId );
                        }}
                        visible={visible}
                    /> 
                );
            } 
            else {
                optionEl = (
                    <div>
                        { inputType } has not been mapped yet and cannot be displayed
                    </div>
                );
            }

            const dropdownOptionSection = (
                <div className={ "child-accordion " + _key + " " + gridWidthClass + " " + hiddenClass } key={ _key }>
                    { optionEl }
                </div>
            );

            dropdownOptionSections.push( dropdownOptionSection );
        }

        const isExpanded = expandedSections[key] || false;
        const sectionClass = isExpanded ? 'accordion-in-layer open' : 'accordion-in-layer';
        const arrowClass = isExpanded ? 'arrow expanded' : 'arrow collapsed';

        const section = (
            <div className={sectionClass} key={key} >
                <button className="accordion-btn" onClick={() => toggleAccordion(key)}>
                    <span>{dropdownLabel}</span>
                    <span className={arrowClass}>
                        <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.39998 6.5C5.20642 6.5 5.01289 6.42797 4.86532 6.28422L0.221553 1.75832C-0.073851 1.47041 -0.073851 1.00363 0.221553 0.71584C0.516838 0.428053 0.995689 0.428053 1.29112 0.71584L5.39998 4.72061L9.50887 0.71598C9.80427 0.428193 10.2831 0.428193 10.5783 0.71598C10.8739 1.00377 10.8739 1.47055 10.5783 1.75846L5.93464 6.28436C5.787 6.42814 5.59347 6.5 5.39998 6.5Z" fill="white"/>
                        </svg>
                    </span>
                </button>
                <div className="accordion-content">
                    { dropdownOptionSections.map( ( dropdownOptionSection ) => {
                        return( dropdownOptionSection );
                    })}
                </div>
            </div>
        );

        sections.push( section );
    }
    
    if ( debug ) {
        return(
            <div>
                {/* DEBUG JSON */}
                <pre>
                    <code>{JSON.stringify( safeFieldOptions , null, 2 )}</code>
                </pre>
            </div>
        );
    } else {
        return(
            <div className="customization-fields">
                <div className="overall-layer-accordion">
                    <button className="toggle-btn" onClick={toggleLayer}>
                        <span>
                            {layerName}
                        </span>
                        { expandLayer &&
                            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.3999 0.5H6.60002H5.99995C5.66882 0.5 6.60002 0.5 5.39998 0.5H0.599962C0.268835 0.5 0 0.768834 0 1.09996C0 1.4312 0.268835 1.70003 0.599962 1.70003H5.39998C5.39998 1.70003 7.08418 1.70003 5.73985 1.69999C4.39552 1.69995 5.66882 1.69999 5.99995 1.69999C6.33118 1.69999 5.17012 1.70003 6.45186 1.69999L7.23032 1.70003H6.60002H11.3999C11.7312 1.70003 12 1.4312 12 1.09996C12 0.768834 11.7312 0.5 11.3999 0.5Z" fill="white"/>
                            </svg>
                        }

                        { !expandLayer &&
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.3999 5.39998H6.60002V0.599962C6.60002 0.268835 6.33118 0 5.99995 0C5.66882 0 5.39998 0.268835 5.39998 0.599962V5.39998H0.599962C0.268835 5.39998 0 5.66882 0 5.99995C0 6.33118 0.268835 6.60002 0.599962 6.60002H5.39998V11.3999C5.39998 11.7312 5.66882 12 5.99995 12C6.33118 12 6.60002 11.7312 6.60002 11.3999V6.60002H11.3999C11.7312 6.60002 12 6.33118 12 5.99995C12 5.66882 11.7312 5.39998 11.3999 5.39998Z" fill="white"/>
                            </svg>
                        }
                    </button>
                    <div className={ "overall-layer-accordion-content" + ( expandLayer ? ' visible' : '' ) }>
                        <h2>Field Options</h2>
                        { sections.map( ( section ) => {
                            return( section );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default EditorFieldOptions;